<script setup lang="ts">
import { UpArrowIconOutlined, UpArrowIconFilled, DownArrowIconFilled } from '@/components/icons'

const props = defineProps<{
  fieldName: string
  fieldKey: string
  sortField: string | null
  sortDirection: 'asc' | 'desc' | null
  clickAction: (field: string) => void
}>()
</script>

<template>
  <div class="header-item" :class="{ 'store-name': props.fieldName === 'Store Name' }">
    <span>{{ props.fieldName }}</span>
    <component
      :is="
        props.sortField === props.fieldKey
          ? props.sortDirection === 'asc'
            ? UpArrowIconFilled
            : props.sortDirection === 'desc'
              ? DownArrowIconFilled
              : UpArrowIconOutlined
          : UpArrowIconOutlined
      "
      @click="() => props.clickAction(props.fieldKey)"
      style="cursor: pointer"
      class="sort-icon"
    />
  </div>
</template>

<style scoped>
.header-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.store-name {
  padding-left: 0.75rem;
  justify-content: flex-start;
}
</style>
